"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validOperatorsForField = exports.ALL_SUPPORTED_CONSTANTS = exports.isSupportedTimeTruncFunction = exports.isSupportedAggregate = exports.isSupportedAggregateFunction = exports.supportedAggregates = exports.supportedTimeTruncFunctions = exports.supportedOperators = exports.supportedAggregatesFunction = exports.supportedTransformationFunctions = void 0;
const lodash_1 = require("lodash");
const constants_1 = require("./constants");
const vizzlySupportedTransformationFunctions = {
    round_to_0_dp: {
        publicName: 'Round to 0dp',
        validDataTypes: ['number'],
    },
    round_to_2_dp: {
        publicName: 'Round to 2dp',
        validDataTypes: ['number'],
    },
};
const supportedTransformationFunctions = (keys) => {
    const supportedAggregates = (0, lodash_1.cloneDeep)(vizzlySupportedTransformationFunctions);
    if (!keys)
        return supportedAggregates;
    let supportedTimeDimensions = {};
    keys.forEach((key) => {
        if (!supportedAggregates[key])
            throw `Transformation function ${key} is not managed by Vizzly`;
        supportedTimeDimensions[key] = supportedAggregates[key];
    });
    return supportedTimeDimensions;
};
exports.supportedTransformationFunctions = supportedTransformationFunctions;
const supportedAggregatesFunction = (queryEngineConfig, dataType, supportedAggregateOptions) => {
    const supportedAggregates = queryEngineConfig.supportedAggregates;
    // Derive default order from supportedAggregates
    const derivedDefaultOrder = Object.keys(supportedAggregates).filter((aggregateId) => supportedAggregates[aggregateId].validDataTypes.includes(dataType));
    // supportedAggregateOptions?.forEach((option) => {
    //   if (!supportedAggregates.hasOwnProperty(option)) {
    //     logWarning(`Unsupported aggregate option: ${option} on ${dataType}`);
    //   }
    // });
    // Determine the order of aggregates to use
    let orderToUse = supportedAggregateOptions && supportedAggregateOptions.length > 0
        ? supportedAggregateOptions.filter((option) => derivedDefaultOrder.includes(option))
        : derivedDefaultOrder;
    // If no valid options found in supportedAggregateOptions, use derivedDefaultOrder
    if (supportedAggregateOptions && supportedAggregateOptions.length > 0 && orderToUse.length === 0) {
        orderToUse = derivedDefaultOrder;
    }
    // Return the aggregates in the order determined
    return orderToUse;
};
exports.supportedAggregatesFunction = supportedAggregatesFunction;
const supportedOperators = (keys) => {
    const supportedOperators = (0, lodash_1.cloneDeep)(constants_1.supportedOperatorsConstants);
    if (!keys)
        return supportedOperators;
    let supportedOperatorsSubset = {};
    keys.forEach((key) => {
        if (!constants_1.supportedOperatorsConstants[key])
            throw `Operator ${key} not managed by Vizzly`;
        supportedOperatorsSubset[key] = constants_1.supportedOperatorsConstants[key];
    });
    return supportedOperatorsSubset;
};
exports.supportedOperators = supportedOperators;
const supportedTimeTruncFunctions = (keys) => {
    const supportedAggregates = (0, lodash_1.cloneDeep)(constants_1.timeDimensionsConstants);
    if (!keys)
        return supportedAggregates;
    let supportedTimeDimensions = {};
    keys.forEach((key) => {
        if (!supportedAggregates[key])
            throw `Time trunc function ${key} not managed by Vizzly`;
        supportedTimeDimensions[key] = supportedAggregates[key];
    });
    return supportedTimeDimensions;
};
exports.supportedTimeTruncFunctions = supportedTimeTruncFunctions;
// Aggregates supported by the Vizzly query engine.
const supportedAggregates = (keys) => {
    const supportedAggregates = (0, lodash_1.cloneDeep)(constants_1.supportedAggregatesConstants);
    if (!keys)
        return supportedAggregates;
    let supportedAggregatesSubset = {};
    keys.forEach((key) => {
        if (!supportedAggregates[key])
            throw `Aggregate ${key} not managed by Vizzly`;
        supportedAggregatesSubset[key] = supportedAggregates[key];
    });
    return supportedAggregatesSubset;
};
exports.supportedAggregates = supportedAggregates;
const isSupportedAggregateFunction = (supportedAggregateFunctions, proposedFunction) => {
    return [...Object.keys(supportedAggregateFunctions), 'none'].includes(proposedFunction);
};
exports.isSupportedAggregateFunction = isSupportedAggregateFunction;
const isSupportedAggregate = (value, supportedAggregates) => {
    if (typeof value !== 'string') {
        return false;
    }
    return supportedAggregates.hasOwnProperty(value);
};
exports.isSupportedAggregate = isSupportedAggregate;
const isSupportedTimeTruncFunction = (supportedTimeFunctions, proposedFunction) => {
    return [...Object.keys(supportedTimeFunctions), 'none'].includes(proposedFunction);
};
exports.isSupportedTimeTruncFunction = isSupportedTimeTruncFunction;
exports.ALL_SUPPORTED_CONSTANTS = [
    { namespace: 'config.supported_operator', constants: constants_1.supportedOperatorsConstants },
    { namespace: 'config.supported_aggregate', constants: constants_1.supportedAggregatesConstants },
    { namespace: 'config.supported_time', constants: constants_1.timeDimensionsConstants },
];
const validOperatorsForField = (field, queryEngineConfig) => {
    let operatorIds = [...Object.keys(queryEngineConfig.supportedOperators)];
    operatorIds = operatorIds.filter((operatorId) => {
        return constants_1.supportedOperatorsConstants[operatorId].validDataTypes.includes(field.dataType);
    });
    return operatorIds;
};
exports.validOperatorsForField = validOperatorsForField;
